export enum PrintBalanceNextAction {
	None,
	CloseDay
}